export default {
  title: 'Nuestros Servicios',
  images:[
    {
      title: 'Asesoría y Consultoría',
      img: require('@/assets/iconos/ico_4.svg')
    },
    {
      title: 'Auditoría',
      img: require('@/assets/iconos/ico_5.svg')
    },
    {
      title: 'Traducción Jurada',
      img: require('@/assets/iconos/ico_6.svg')
    },
    {
      title: 'Seminarios',
      img: require('@/assets/iconos/ico_7.svg')
    },
    {
      title: 'Reclutamiento',
      img: require('@/assets/iconos/ico_8.svg')
    },
    {
      title: 'Outsourcing',
      img: require('@/assets/iconos/ico_9.svg')
    },
    {
      title: 'Tecnología y Sistemas',
      img: require('@/assets/iconos/ico_10.svg')
    },
    {
      title: 'Impuestos y Legal',
      img: require('@/assets/iconos/ico_11.svg')
    }
  ],
  services:[
    {
      title: 'Asesoría y Consultoría',
      image: require('@/assets/images/asesorias.jpg'),
      list: [
        '- Financiera y Empresarial.',
        '- Legal.',
        '- Fiscal Corporativo.',
        '- Laboral Corporativo.',
        '- Riesgos.',
        '- Control Interno.',
        '- Constitución de Empresas.',
        '- Tecnología y Sistemas.',
      ],
      position: 'left'
    },
    {
      title: 'Auditoría',
      image: require('@/assets/images/auditoria.jpg'),
      list: [
        '- Auditoría de Estados Financieros.',
        '- Auditoría Especial.',
        '- Auditoría por Rubro especifico.',
        '- Auditoría Forense.',
        '- Auditoría en Sistemas –PED-.',
        '- Auditoría Interna.',
        '- Due Diligence.',
        '- Diagnósticos Financieros y sus Estrategias.',
      ],
      position: 'right'
    },
    {
      title: 'Impuestos',
      image: require('@/assets/images/impuesto.jpg'),
      list: [
        '- Estudios de Precios de Transferencia.',
        '- Análisis al Cumplimiento de los Deberes Formales.',
        '- Estrategias de Negocio.',
        '- Planeación Fiscal.',
        '- Defensa Fiscal.',
        '- Recuperación de Crédito Fiscal.',
        '- Diseños de Procedimientos como una Herramienta de Análisis.',
        '- Diagnósticos fiscales.',
      ],
      position: 'left'
    },
    {
      title: 'Outsourcing',
      image: require('@/assets/images/outsourcing.jpg'),
      list: [
        '- Contabilidad.',
        '- Recursos Humanos.',
        '- Nóminas.',
        '- Auditoría Interna.',
      ],
      position: 'right'
    },
    {
      title: 'Otros Servicios',
      image: require('@/assets/images/otros_servicios.jpg'),
      list: [
        '- Traducción Jurada: Inglés-Español, Español-Inglés.',
        '- Asuntos Mercantiles, Negocios Jurídicos y Notariado.',
        '- Otros asuntos legales.',
      ],
      position: 'left'
    },
    {
      title: 'Seminarios',
      image: require('@/assets/images/seminarios.jpg'),
      list: [
        '- De actualización Fiscal Legislación Vigente (IVA, ISO, ISR, Código Tributario etc.).',
        '- Ley de Lavado de dinero u otros activos y para prevenir y reprimir el Financiamiento del Terrorismo.',
        '- Conversión de estados financieros de principios de contabilidad generalmente aceptados (PCGA) a NIIF (normas internacionales de información financiera).',
        '- Cómo elaborar el estado de flujo de efectivo.',
        '- Control interno basado en riesgos (COSO).',
        '- Cómo elaborar una Auditoría de estados financieros con base a normas Internacionales de Auditoría.',
        '- Organización de un Departamento de Auditoría Interna.',
        '- Fortalecimiento de un adecuado control interno.',
        '- Ley de extinción de dominio y sus implicaciones como negocio en marcha.',
        '- Aplicación de estudios de precios de transferencia.',
        '- Otros.',
      ],
      position: 'right'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/text/es/services.js